import avtarMale from "../image/male_avtar.png";
import avtarFemale from "../image/female_avtar.png";

const data = [
  {
    id: 1,
    name: "Kehinde Onifade",
    dob: "09 April",
    age: 24,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 2,
    name: "Taiwo Onifade",
    dob: "09 April",
    age: 24,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 3,
    name: "Tolu Jacobs",
    dob: "17 April",
    age: 25,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 4,
    name: "Oyenike Oyeronke",
    dob: "07 November",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 5,
    name: "Kehinde Odeleye",
    dob: "08 August",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 6,
    name: "Akinola Kayode",
    dob: "20 November",
    age: 25,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 7,
    name: "Ajenifuja Sunday",
    dob: "24 November",
    age: 25,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 8,
    name: "Hammed Zainab",
    dob: "14 November",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 9,
    name: "Agbajelola Rukayat",
    dob: "22 November",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 10,
    name: "Bello Ridwan",
    dob: "08 August",
    age: 25,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 11,
    name: "Taiwo Oyeronke",
    dob: "16 August",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 12,
    name: "Kehinde Oyeroke",
    dob: "16 August",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 13,
    name: "Oyekanmi Jamiu",
    dob: "16 August",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 14,
    name: "Afolabi Shakirat",
    dob: "21 August",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 15,
    name: "Ajibola Fatimah",
    dob: "23 August",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 16,
    name: "Uthman Fareedah",
    dob: "25 August",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 17,
    name: "Olajide Ataba",
    dob: "26 August",
    age: 25,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 18,
    name: "Abdurrazaq Oyetunji",
    dob: "08 February",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 19,
    name: "Salaudeen Monisola",
    dob: "21 September",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 20,
    name: "Damola Odeyemi",
    dob: "9 September",
    age: 25,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 21,
    name: "Samuel Akindele",
    dob: "10 September",
    age: 25,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 22,
    name: "Opeyemi Ayodeji",
    dob: "30 December",
    age: 24,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 23,
    name: "Islamyat Arogundade",
    dob: "30 December",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 24,
    name: "Miracle Owolabi",
    dob: "18 December",
    age: 25,
    gender: "Male",
    image: `${avtarMale}`,
  },
  {
    id: 25,
    name: "Temitayo Oke",
    dob: "12 February",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 26,
    name: "Taiwo Yusuf",
    dob: "25 December",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
  {
    id: 27,
    name: "Kehinde Yusuf",
    dob: "25 December",
    age: 25,
    gender: "Female",
    image: `${avtarFemale}`,
  },
];

export default data;
